import source from '../downloaded/stats.json' assert { type: 'json' };
import sourceStatsDescr from '../downloaded/statsDescr.json' assert { type: 'json' };


export const stats_descr = sourceStatsDescr;
export const stats = [];
for (const row of source) {
  const {
    stat_key,
    value,
    perk,
    name,
    descr,
  } = row;

  stats.push({
    stat_key,
    value: +value,
    perk,
    name,
    descr,
  });
}
